export default {
  rossoCorsa: '#CE1212',
  softBlack: '#141414',
  softBlack48: '#1414147A',
  whiteSmoke: '#F6F4F4',
  blueYonder: '#4A6FA5',
  earthYellow: '#DEB06A',
  neptune: '#7CA1A1',
  neptune12: '#7CA1A11F',
  trueBlack: '#090909',
}
